export default "__VITE_ASSET__BOuJyx1A__"